import script from "./passport.vue?vue&type=script&setup=true&lang=js"
export * from "./passport.vue?vue&type=script&setup=true&lang=js"

import "./passport.vue?vue&type=style&index=0&id=77d899ea&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d899ea"]])

export default __exports__